import $i18n, { langList } from '@alife/panda-i18n';
import React, { useState, useCallback } from 'react';
import { CnMenu, CnDropdown, CnMenuItem } from '@cainiaofe/cn-ui';
import './index.scss';
function removeURLParameter(url, parameter) {
    var urlParts = url.split('?');
    if (urlParts.length >= 2) {
        var prefix = encodeURIComponent(parameter) + '=';
        var parts = urlParts[1].split(/[&;]/g);
        // 遍历参数，删除指定参数
        for (var i = 0; i < parts.length; i++) {
            if (parts[i].lastIndexOf(prefix, 0) !== -1) {
                parts.splice(i, 1);
                i--;
            }
        }
        // 重构URL
        url = urlParts[0] + (parts.length > 0 ? '?' + parts.join('&') : '');
        return url;
    }
    else {
        return url;
    }
}
const Languages = ({ languageList, handleChangeLang, isReverse }) => {
    const [selectedKeys, setSelectedKeys] = useState($i18n.getLang());
    const onSelectLanguage = useCallback((_selectedKeys) => {
        const val = _selectedKeys?.[0];
        setSelectedKeys(val);
        $i18n.setLang(val);
        handleChangeLang && handleChangeLang(val);
        const newUrl = removeURLParameter(location.href, 'lang');
        location.href = newUrl;
    }, []);
    const list = langList.filter((item) => languageList?.includes?.(item.value)) || [];
    const languagesNode = (React.createElement("div", { className: "language-content" },
        React.createElement("svg", { t: "1642585526422", className: "icon", viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "p-id": "1955", width: "20", height: "20" },
            React.createElement("path", { d: "M529.066667 874.666667H512c-200.533333 0-362.666667-162.133333-362.666667-362.666667S311.466667 149.333333 512 149.333333h21.333333c192 12.8 341.333333 170.666667 341.333334 362.666667 0 174.933333-123.733333 320-290.133334 354.133333-17.066667 4.266667-38.4 8.533333-55.466666 8.533334z m-34.133334-42.666667v-145.066667l-59.733333-81.066666 123.733333-123.733334 59.733334 59.733334h115.2l76.8 76.8v8.533333c12.8-38.4 21.333333-76.8 21.333333-119.466667 0-166.4-128-302.933333-290.133333-320l-89.6 89.6L512 341.333333v110.933334L409.6 554.666667 226.133333 366.933333c-21.333333 42.666667-34.133333 93.866667-34.133333 145.066667 0 170.666667 132.266667 311.466667 302.933333 320zM345.6 238.933333c-38.4 25.6-68.266667 51.2-93.866667 89.6l162.133334 162.133334 55.466666-55.466667V358.4L392.533333 281.6l17.066667-17.066667 72.533333-72.533333c-51.2 8.533333-93.866667 21.333333-136.533333 46.933333z m192 430.933334V832c42.666667-4.266667 89.6-17.066667 136.533333-42.666667 38.4-21.333333 68.266667-51.2 93.866667-85.333333V640l-51.2-51.2H597.333333l-42.666666-42.666667-64 64 46.933333 59.733334z", fill: isReverse ? '#000000' : '#ffffff', "p-id": "1956" })),
        React.createElement("span", null, langList?.find?.((item) => item?.value === $i18n.getLang())?.label),
        React.createElement("svg", { t: "1642585440250", className: "icon", viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "p-id": "1741", width: "24", height: "24" },
            React.createElement("path", { d: "M512 648.533333l-192-192 29.866667-29.866666 162.133333 162.133333 162.133333-162.133333 29.866667 29.866666-192 192z", fill: isReverse ? '#000000' : '#ffffff', "p-id": "1742" }))));
    return (React.createElement(CnDropdown, { align: "tc bc", trigger: languagesNode, wrapperClassName: "language-dropdown-wrap" },
        React.createElement(CnMenu, { selectMode: "single", selectedKeys: selectedKeys, onSelect: onSelectLanguage }, list.map((item) => {
            return (React.createElement(CnMenuItem, { key: item.value },
                React.createElement("span", { "data-i18n-ignore": true }, item.label)));
        }))));
};
export default Languages;
